// store/faviconStore.ts
import create from 'zustand';

interface FaviconState {
  faviconUrl: string;
  setFaviconUrl: (url: string) => void;
}

const useFaviconStore = create<FaviconState>((set) => ({
  faviconUrl: '',
  setFaviconUrl: (url) => set({ faviconUrl: url }),
}));

export default useFaviconStore;
